import { Button } from "@mui/material";
import { CartContext } from "./provider.js";
import { ChevronRight } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
export const AddToCartButton = ({ buttonProps, label, productId }) => {
    const { addItemAsync, disableInteraction, isLoading } = React.useContext(CartContext);
    const [added, setAdded] = React.useState(false);
    const { t } = useTranslation(["c-cart", "c-common"]);
    const handleClick = async () => {
        try {
            await addItemAsync({ id: productId ?? "", quantity: 1 });
            setAdded(true);
        }
        catch (error) {
            // do nothign as we handle the error inside the cart provider
        }
    };
    return (React.createElement(React.Fragment, null, added ? (React.createElement(Button, { color: "success", "data-testid": "go-to-cart-btn", endIcon: React.createElement(ChevronRight, null), href: t("c-common:url-cart", "/warenkorb"), LinkComponent: Link, variant: "contained", ...buttonProps }, t("button-label-go-to-cart", "Warenkorb anzeigen"))) : (React.createElement(LoadingButton, { color: "primary", "data-testid": "add-to-cart-btn", disabled: !isLoading?.addItem && disableInteraction, loading: isLoading?.addItem, loadingPosition: "center", onClick: handleClick, variant: "contained", ...buttonProps }, !!label ? label : t("c-cart:button-label-add-to-cart", "In den Warenkorb")))));
};
//# sourceMappingURL=add-to-cart-button.js.map